import React from 'react';
import { Target, Sparkles, Shield, Zap } from 'lucide-react';

const steps = [
  {
    icon: Target,
    title: 'Choose Your Theme',
    description: 'Select from cosmic, urban, mythical, or tech-based themes for your team.'
  },
  {
    icon: Shield,
    title: 'Add Keywords',
    description: 'Customize your team name with keywords that represent your heroes\' powers.'
  },
  {
    icon: Sparkles,
    title: 'Generate Names',
    description: 'Our AI creates unique superhero team names based on your choices.'
  },
  {
    icon: Zap,
    title: 'Pick Your Legacy',
    description: 'Choose the perfect name that will strike fear into villains\' hearts.'
  }
];

export default function SuperheroHowItWorks() {
  return (
    <section className="py-20 bg-violet-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          How Our Superhero Name Generator Works
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-violet-200 transform -translate-y-1/2">
                  <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2">
                    <div className="w-3 h-3 bg-violet-200 rotate-45 transform origin-center"></div>
                  </div>
                </div>
              )}
              <div className="relative text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-violet-100 mb-4 transform transition-transform hover:scale-110">
                  <step.icon className="w-8 h-8 text-violet-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white p-8 rounded-xl shadow-lg max-w-3xl mx-auto">
          <h3 className="text-2xl font-semibold text-center text-gray-900 mb-6">
            Advanced AI Name Generation
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <h4 className="font-semibold text-violet-600">What We Consider:</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-violet-500 rounded-full"></div>
                  <span>Team powers and abilities</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-violet-500 rounded-full"></div>
                  <span>Origin stories</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-violet-500 rounded-full"></div>
                  <span>Team dynamics</span>
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h4 className="font-semibold text-violet-600">Name Qualities:</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-violet-500 rounded-full"></div>
                  <span>Memorable and impactful</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-violet-500 rounded-full"></div>
                  <span>Theme appropriate</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-violet-500 rounded-full"></div>
                  <span>Unique and distinctive</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}